/* src/app/views/legal-text-contract/legal-text-contract-bra-preb/legal-text-contract-bra-preb.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 20px 32px;
  margin: 0 auto 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}
.title-top {
  position: static;
  padding-top: 1.5em;
  color: #000000;
  text-align: left;
  font-weight: bolder;
}
.title-top--centered {
  text-align: center;
}
/*# sourceMappingURL=legal-text-contract-bra-preb.component-XET5EJGA.css.map */
